import { render } from "./fixedImg.vue?vue&type=template&id=7e069764"
import script from "./fixedImg.vue?vue&type=script&lang=js"
export * from "./fixedImg.vue?vue&type=script&lang=js"

import "./fixedImg.vue?vue&type=style&index=0&id=7e069764&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__